module.exports = __webpack_public_path__ + "static/img/shuifei.055971c3.png";